export const _path = {
    CLINICA: '/clinica',
    ACCOUNT: '/account'
}

const menu = [{
    layout: 'clinica',
    title: 'Facturación',
    url: `${_path.CLINICA}/facturas`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Facturas', url: `${_path.CLINICA}/facturas` },
            { title: 'Facturas pendientes', url: `${_path.CLINICA}/facturascc` },
            { title: 'Recibos de caja', url: `${_path.CLINICA}/facturas/recibos` },
            { title: 'Proformas', url: `${_path.CLINICA}/cotizaciones` }
        ],
    },
}, {
    layout: 'clinica',
    title: 'Agenda',
    url: `${_path.CLINICA}/agenda`
}, {
    layout: 'clinica',
    title: 'Clientes',
    url: `${_path.CLINICA}/clientes`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Gestion de clientes', url: `${_path.CLINICA}/clientes` },

        ],
    },
}, {
    layout: 'clinica',
    title: 'Almacén',
    url: '',
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Inventario', url: `${_path.CLINICA}/inventario/stock` },     
            { title: 'Compras', url: `${_path.CLINICA}/movimientos/compras` },     
            { title: 'Ajuste de entrada', url: `${_path.CLINICA}/movimientos/entradas` },    
            { title: 'Inventario Inicial', url: `${_path.CLINICA}/movimientos/inv-inicial` },
            { title: 'Ajuste de salida', url: `${_path.CLINICA}/movimientos/salidas` },
            { title: 'Kardex', url: `${_path.CLINICA}/reports/kardex` },
            { title: 'Stock', url: `${_path.CLINICA}/reportes/stock` },
            
        ],
    },
}, {
    layout: 'clinica',
    title: 'Catalogos',
    url: `${_path.CLINICA}/articulos/marco`,
    submenu: {
        type: 'menu',
        menu: [
            {
                title: 'Productos',
                url: `${_path.CLINICA}/articulos/marco`,
                submenu: [
                    { title: 'Marco/Aro', url: `${_path.CLINICA}/articulos/marco` },
                    { title: 'Lentes oftalmicos', url: `${_path.CLINICA}/articulos/lentesOftalmicos` },
                    { title: 'Lentes de contacto', url: `${_path.CLINICA}/articulos/lentesDeContacto` },
                    { title: 'Lentes Esclerales', url: `${_path.CLINICA}/articulos/lentesEsclerales` },
                    { title: 'Accesorios', url: `${_path.CLINICA}/articulos/accesorios` },
                    { title: 'Servicios', url: `${_path.CLINICA}/articulos/servicio` },
                ]
            },
            { title: 'Doctores', url: `${_path.CLINICA}/agenda/doctores` },
            { title: 'Proveedores', url: `${_path.CLINICA}/proveedores` }, 
            { title: 'Profesiones', url: `${_path.CLINICA}/profesiones` }, 
            { title: 'Categorias', url: `${_path.CLINICA}/categorias` }, 
            { title: 'Forma de pago', url: `${_path.CLINICA}/forma-pago` }, 
            { title: 'Tipo de pago', url: `${_path.CLINICA}/tipo-pago` }, 
            { title: 'Vendedores', url: `${_path.CLINICA}/agenda/vendedores` },
            { title: 'Laboratorios', url: `${_path.CLINICA}/clientes` },
            { title: 'Bancos', url: `${_path.CLINICA}/bancos` },
        ],
    },
}, {   
    layout: 'clinica',
    title: 'Reportes',
    url: '',
    submenu: {
        type: 'menu',
        menu: [
            {
                title: 'Clientes',
                url: ``,
                submenu: [
                    { title: 'Lista de clientes', url: `${_path.CLINICA}/reportes/clientes/lista` },
                    { title: 'Clientes deudores', url: `${_path.CLINICA}/reportes/clientes/deudores` },
                    { title: 'Clientes por edad', url: `${_path.CLINICA}/reportes/clientes/poredad` },
                ]
            }, {
                title: 'Graduaciones',
                url: ``,
                submenu: [
                    { title: 'Lista de graduaciones', url: `${_path.CLINICA}/reportes/records/lista` },
                ]
            }, {
                title: 'Facturas',
                url: ``,
                submenu: [
                    { title: 'Facturas de hoy', url: `${_path.CLINICA}/reportes/billsOfDay` },
                    { title: 'Facturas por rango de fecha', url: `${_path.CLINICA}/reportes/bill/season` },
                    { title: 'Facturas por cliente', url: `${_path.CLINICA}/reportes/billsByClient` },
                    { title: 'Venta del mes', url: `${_path.CLINICA}/reportes/sales` },
                    { title: 'Gráfico por mes', url: `${_path.CLINICA}/reportes/billsByMonth` },
                    { title: 'Gráfico por dia', url: `${_path.CLINICA}/reportes/billsByDays` },
                ]
            }, {
                title: 'Articulos',
                url: ``,
                submenu: [
                    { title: 'Venta por articulos', url: `${_path.CLINICA}/reportes/items/lista` },
                    { title: 'Listado General', url: `${_path.CLINICA}/reportes/items/inventario` },                    
                    { title: 'Valoracion', url: `${_path.CLINICA}/reportes/valoracion-almacen` },
                    

                ]
            }, {
                title: 'Proveedores',
                url: ``,
                submenu: [
                    { title: 'Cuentas por pagar', url: `${_path.CLINICA}/reportes/cuentasporpagar` },
                    { title: 'Proveedores', url: `${_path.CLINICA}/reportes/proveedores` },
                ]
            },            
            { title: 'SMS Enviados', url: `${_path.CLINICA}/sms` },
            { title: 'SMS Creditos', url: `${_path.CLINICA}/sms/credits` },
            
        ],
    }
}, {
    layout: 'clinica',
    title: 'Configuracion',
    url: '',
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Usuarios', url: `${_path.CLINICA}/usuarios` },
            { title: 'Perfiles', url: `${_path.CLINICA}/roles` },
            { title: 'Permisos', url: `${_path.CLINICA}/recursos` },
            { title: 'Plantillas SMS', url: `${_path.CLINICA}/plantillas` },           
            { title: 'Tabla de conversion toricos', url: `${_path.CLINICA}/contactostoricos` },
            { title: 'Tabla de conversion esferico', url: `${_path.CLINICA}/contactosesferico` },          
            { title: 'Tabla de Lentes Sclerales', url: `${_path.CLINICA}/scleral-table` },          
            { title: 'Actividades', url: `${_path.CLINICA}/actividades` },
            { title: 'Catalogos', url: `${_path.CLINICA}/catalogos/maestros` },
            { title: 'Tasa de cambio', url: `${_path.CLINICA}/tasa-de-cambio` },
            { title: 'Herramientas', url: `${_path.CLINICA}/app` }
            
        ],
    },
}
];


export default menu;